import React from "react";

const Baner = () => {
  return (
    <div className="baner">
      <div className="baner-text">
        <p>
          LLEGO CYBER MONDAY.. con el código CODERHOUSE obtén un 15% de
          descuento en tus compras
        </p>
        <p>ENVIO GRATIS a partir de tus compras superiores a $35000</p>
        <p>
          LLEGO CYBER MONDAY.. con el código CODERHOUSE obtén un 15% de
          descuento en tus compras
        </p>
        <p>ENVIO GRATIS a partir de tus compras superiores a $35000</p>
      </div>
    </div>
  );
};

export default Baner;
